'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ngRedux = require('ng-redux');

var _ngRedux2 = _interopRequireDefault(_ngRedux);

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CompetitorsBySchoolReportController = function () {
  function CompetitorsBySchoolReportController($q, feis, $ngRedux, fRouterHistoryService, msgService, fCSVReportsService, fRegistrationService, fFeisService) {
    var _this = this;

    _classCallCheck(this, CompetitorsBySchoolReportController);

    this.$q = $q;
    this.fRouterHistoryService = fRouterHistoryService;
    this.$ngRedux = $ngRedux;
    this.msgService = msgService;
    this.fCSVReportsService = fCSVReportsService;
    this.feis = feis;
    this._feis = fFeisService;
    this._reg = fRegistrationService.for(feis.id);

    this.participantsBySchool;
    this.$q.all([this._reg.all(), this._feis.teachers(this.feis.id)]).then(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          participants = _ref2[0],
          teachers = _ref2[1];

      // Group participants by school
      _this.participantsBySchool = participants.reduce(function (acc, participant) {
        var schoolName = participant.school.name;
        if (!acc[schoolName]) {
          acc[schoolName] = { participants: [] };
        }

        var p = {
          fname: participant.fname,
          lname: participant.lname,
          events: participant.events,
          balance: Array.isArray(participant.registrations) && participant.registrations.length > 0 ? participant.registrations[0].balance : 0
        };

        acc[schoolName].participants.push(p);
        return acc;
      }, {});

      // for every school, add teachers
      Object.entries(_this.participantsBySchool).forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            school = _ref4[0],
            schoolData = _ref4[1];

        var schoolTeachers = teachers.filter(function (t) {
          return t.school.name === school;
        });
        schoolData.teachers = schoolTeachers;

        // sort events by number only
        schoolData.participants.forEach(function (p) {
          p.events.sort(function (a, b) {
            return parseInt(a.match(/^\d+/)[0], 10) - parseInt(b.match(/^\d+/)[0], 10);
          });
        });
      });

      var schoolNames = Object.keys(_this.participantsBySchool).sort();
      var sortedSchools = {};
      schoolNames.forEach(function (s) {
        sortedSchools[s] = _this.participantsBySchool[s];
      });
      _this.participantsBySchool = sortedSchools;
    });
  }

  _createClass(CompetitorsBySchoolReportController, [{
    key: 'back',
    value: function back() {
      this.fRouterHistoryService.back();
    }
  }, {
    key: 'generateExcelReport',
    value: function generateExcelReport() {
      var csv = [];

      function extractTeacherData(teachers) {
        return teachers.map(function (teacher) {
          return teacher.fname + ' ' + teacher.lname + ': ' + teacher.email;
        }).join(', ');
      }

      Object.entries(this.participantsBySchool).forEach(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            school = _ref6[0],
            schoolData = _ref6[1];

        csv.push([school, extractTeacherData(schoolData.teachers) ? '- Teachers: ' + extractTeacherData(schoolData.teachers) : extractTeacherData(schoolData.teachers)]);
        schoolData.participants.forEach(function (p) {
          csv.push([''].concat(p.fname + ' ' + p.lname + ' (Account Balance Due: $' + p.balance + ')'));
          p.events.forEach(function (e) {
            return csv.push(['', '', e]);
          });
        });
      });

      this.fCSVReportsService.prepareCSV(csv, this.feis.slug + '_Competitors_By_School.csv');
    }
  }]);

  return CompetitorsBySchoolReportController;
}();

exports.default = angular.module('ifeis.routes.feiseanna.one.admin.reports.competitors-by-school-report', []).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.reports.competitors-by-school-report', {
    url: '/competitors-by-school-report',
    template: require('./tpl.html'),
    controller: CompetitorsBySchoolReportController,
    controllerAs: 'ctrl'
  });
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/reports/competitors-by-school/index.js
// module id = 561
// module chunks = 0